import React from 'react';
import { motion } from 'framer-motion';
const weeks = [{
  num: 1,
  title: 'Semana 1 · Vocales',
  desc: 'Reconocer y dominar las vocales.'
}, {
  num: 2,
  title: 'Semana 2 · Sílabas',
  desc: 'Aprender sílabas y combinaciones simples.'
}, {
  num: 3,
  title: 'Semana 3 · Palabras',
  desc: 'Construir palabras completas.'
}, {
  num: 4,
  title: 'Semana 4 · Frases y cuentos',
  desc: 'Leer frases y pequeños cuentos.'
}];
export function ThirtyDayPlan() {
  return <section className="py-12 md:py-16 bg-white" data-id="element-312">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-313">
        <div className="text-center mb-8" data-id="element-314">
          <span className="text-slate-500 font-bold tracking-wider uppercase text-sm mb-2 block" data-id="element-315">
            Tu plan de acción
          </span>
          <h2 className="text-3xl font-bold mb-4 text-navy" data-id="element-316">
            Tu Plan de los Próximos 30 Días
          </h2>
          <p className="text-slate-600" data-id="element-317">
            Un camino simple, semana a semana. No necesitás hacerlo perfecto —
            necesitás hacerlo consistente.
          </p>
        </div>

        <div className="space-y-4 mb-8" data-id="element-318">
          {weeks.map((w, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="flex gap-4 bg-slate-50 p-4 rounded-xl border border-slate-100" data-id="element-319">
              <div className="w-8 h-8 rounded-full bg-navy text-white flex items-center justify-center font-bold flex-shrink-0" data-id="element-320">
                {w.num}
              </div>
              <div data-id="element-321">
                <h3 className="font-bold text-navy mb-1" data-id="element-322">{w.title}</h3>
                <p className="text-sm text-slate-600" data-id="element-323">{w.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-324">
          <p className="text-sm font-medium text-slate-500 italic" data-id="element-325">
            No buscamos perfección. Buscamos progreso.
          </p>
        </div>
      </div>
    </section>;
}